import tagsService from './tagsService'

export default tagsService



// WEBPACK FOOTER //
// ../src/services/tagsService/index.js